import { useSelector } from '@lumapps/redux/react';

import { connectedUserSelector } from '../ducks/selectors';
import { User, UseUserOptions } from '../types';
import { useUser } from './useUser';

/**
 * Hooks that retrieves information from the current connected user, as well as enhances it with other calculated informations:
 * - User fields dependening on the organization / api profile fields
 * - Retrieve information in order to create a user's avatar.
 * - Retrieve information in order to create a link towards the user's profile.
 * - Retrieve the user's full name
 * - Retrieve the user's profile picture
 * @returns useCurrentUser
 */
export const useCurrentUser = (options?: UseUserOptions) => {
    const currentUser = useSelector(connectedUserSelector);

    return useUser<User>(currentUser, options);
};
